import { Button2, cn } from '@valuecase/ui-components'
import { Chip, ChipClose, ChipLabel } from '@valuecase/ui-components/src/components/ui/chip'
import { useCallback, useMemo } from 'react'

interface SpaceMultiSelectActionBarProps {
  selectedCount: number
  onCounterClick: () => void
  onArchiveClick: () => void
  onDeleteClick: () => void
  onChangeOwnerClick: () => void
  className?: string
  archiveButtonDisabled?: boolean
  archiveButtonText?: string
}

const SpaceMultiSelectActionBar = ({
  className,
  selectedCount,
  onCounterClick,
  onArchiveClick,
  onDeleteClick,
  onChangeOwnerClick,
  archiveButtonDisabled,
  archiveButtonText = 'Archive',
}: SpaceMultiSelectActionBarProps) => {
  const spacesSelectedLabel = useMemo(() => {
    if (selectedCount === 0) return 'No spaces selected'
    if (selectedCount === 1) return '1 space selected'
    return `${selectedCount} spaces selected`
  }, [selectedCount])

  const handleArchiveClick = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault()
      e.stopPropagation()
      onArchiveClick()
    },
    [onArchiveClick],
  )

  const handleDeleteClick = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault()
      e.stopPropagation()
      onDeleteClick()
    },
    [onDeleteClick],
  )

  const handleChangeOwnerClick = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault()
      e.stopPropagation()
      onChangeOwnerClick()
    },
    [onChangeOwnerClick],
  )

  return (
    <div
      className={cn(
        'absolute left-1/2 -translate-x-1/2 bottom-20 flex justify-between items-center p-2 gap-[26px] bg-brand-dark-blue-s1 rounded-md shadow-lg z-30',
        className,
        {
          'opacity-0 pointer-events-none': selectedCount === 0,
        },
      )}
    >
      <Chip
        variant='ghost'
        className='bg-white/15 border border-white/30 px-2 py-[6px] hover:bg-white/25'
      >
        <ChipLabel className='text-xs font-semibold text-white/75'>{spacesSelectedLabel}</ChipLabel>
        <ChipClose className='text-white/75 hover:text-white/90' onClick={onCounterClick} />
      </Chip>

      <Button2
        variant='dark-blue'
        size='small'
        leadingIcon='shuffle'
        onClick={handleChangeOwnerClick}
      >
        Change Owner
      </Button2>

      {!archiveButtonDisabled && (
        <Button2
          variant='dark-blue'
          size='small'
          leadingIcon='file-tray'
          onClick={handleArchiveClick}
        >
          {archiveButtonText}
        </Button2>
      )}

      <Button2
        variant='dark-blue'
        size='small'
        leadingIcon='trash-outline'
        onClick={handleDeleteClick}
      />
    </div>
  )
}

export default SpaceMultiSelectActionBar
